<template>
	<div class="departmentTableWrar">
		<div class="head">
			{{ items.name }}
		</div>
		<div class="tableWrapper">
			<main-table
					padding="0"
					:flag="flag"
					:headers="getHeaders"
					:listItems="items.employees"
					@updateClickButton="onClickButton($event, flag)"
					:is-hide-header="false"
					items-per-page-amount="All"
					:pages="[ 10, 20, 50, 100, 200, 500, 'All' ]"

					:indeterminate="indeterminate"
					:checkAll="checkAll"
					@updateCheckOrder="onCheckOrder"
					@updateCheckOrders="onCheckOrders"
					:is-pagination="false"
			></main-table>
		</div>
	</div>
</template>

<script>
import { tableHolidayDepartment } from "@/pages/Settings/UserAccountSettings/constants";

export default {
	name: "DepartmentTable",
	props: {
		items: Object,
	},
	computed: {
		getHeaders() {
			return tableHolidayDepartment;
		},
		isDisabled() {
			return this.selected.length === 0;
		},
	},
	data: () => ({
		flag: 'tableHolidayDepartment',

		checkAll: false,
		selected: [],
		indeterminate: false,

	}),
	methods: {
		onCheckOrder(orderId) {
			const idx = this.selected.findIndex(({ id }) => id === orderId);
			const item = this.items.employees.find(({ id }) => id === orderId);
			if (idx === -1) {
				this.selected.push(item);
			} else {
				this.selected.splice(idx, 1);
			}

			if (!this.selected.length) {
				this.indeterminate = false;
				this.checkAll = false;
			}

			if (this.selected.length && this.selected.length !== this.items.employees.length) {
				this.indeterminate = true;
			}

			if (this.selected.length === this.items.employees.length) {
				this.indeterminate = false;
				this.checkAll = true;
			}
		},
		onCheckOrders(value) {
			if (value) {
				this.selected = this.items.employees.map((body) => body);
			} else {
				this.selected = [];
				this.indeterminate = false;
			}

			this.checkAll = value;
			this.items.employees.forEach((item) => (item.isCheck = value));
		},

		onClickButton({ key, item }, nameComponent) {
			console.info('%c [ onClickButton   ] ', 'color:#bada55', key, item, nameComponent );
			// this.$emit('updatePPWFilesClickButton', { key, item, nameComponent });
		},
	}
};
</script>

<style scoped lang="scss">
@import "departmentTable";
</style>
